<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="section-header mb-3">
      <span class="section-label">إعداد السنوات الدراسية</span>
      <div class="section-divider"></div>
    </div>

    <div v-if="loading" class="text-center py-5">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
    </div>

    <template v-else>
      <!-- Primary -->
      <div class="stage-section mb-4" v-if="gradesByStage.primary.length">
        <h5 class="stage-title">
          <i class="pi pi-star me-2"></i> المرحلة الابتدائية
        </h5>
        <div class="row g-3">
          <div
            v-for="grade in gradesByStage.primary"
            :key="grade.id"
            class="col-xl-2 col-lg-3 col-md-4 col-6"
          >
            <div
              class="grade-toggle-card"
              :class="{ 'grade-toggle-card--active': grade.is_active }"
              @click="toggle(grade)"
            >
              <div class="grade-toggle-card__name">{{ grade.name }}</div>
              <div class="grade-toggle-card__badge">
                <span v-if="grade.is_active" class="badge bg-success">مفعّل</span>
                <span v-else class="badge bg-secondary">معطّل</span>
              </div>
              <div class="grade-toggle-card__switch">
                <i :class="grade.is_active ? 'pi pi-toggle-on text-success' : 'pi pi-toggle-off text-secondary'" style="font-size: 1.6rem;"></i>
              </div>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.is_reservation_open ? 'btn btn-sm btn-outline-success' : 'btn btn-sm btn-outline-danger'"
                :title="grade.is_reservation_open ? 'اضغط لإغلاق الحجز لهذه السنة.' : 'اضغط لفتح الحجز لهذه السنة.'"
                @click.stop="toggleReservation(grade)"
              >
                <i :class="grade.is_reservation_open ? 'pi pi-lock-open me-1' : 'pi pi-lock me-1'"></i>
                {{ grade.is_reservation_open ? 'الحجز مفتوح' : 'الحجز مغلق' }}
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn btn btn-sm btn-outline-primary"
                title="إعدادات نموذج التسجيل"
                @click.stop="openFormSettings(grade)"
              >
                <i class="pi pi-cog me-1"></i>
                إعدادات النموذج
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.is_subscription_enabled ? 'btn btn-sm btn-outline-warning' : 'btn btn-sm btn-outline-secondary'"
                title="إعدادات الاشتراك والأسعار"
                @click.stop="openSubSettings(grade)"
              >
                <i class="pi pi-money-bill me-1"></i>
                {{ grade.is_subscription_enabled ? 'الاشتراك مفعّل' : 'إعدادات الاشتراك' }}
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.reservation_start_at ? 'btn btn-sm btn-outline-info' : 'btn btn-sm btn-outline-secondary'"
                title="تحديد موعد فتح الحجز لهذه السنة الدراسية"
                @click.stop="openScheduleModal(grade)"
              >
                <i class="pi pi-calendar-clock me-1"></i>
                {{ grade.reservation_start_at ? formatSchedule(grade.reservation_start_at) : 'تحديد موعد الحجز' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Prep -->
      <div class="stage-section mb-4" v-if="gradesByStage.prep.length">
        <h5 class="stage-title">
          <i class="pi pi-book me-2"></i> المرحلة الإعدادية
        </h5>
        <div class="row g-3">
          <div
            v-for="grade in gradesByStage.prep"
            :key="grade.id"
            class="col-xl-2 col-lg-3 col-md-4 col-6"
          >
            <div
              class="grade-toggle-card"
              :class="{ 'grade-toggle-card--active': grade.is_active }"
              @click="toggle(grade)"
            >
              <div class="grade-toggle-card__name">{{ grade.name }}</div>
              <div class="grade-toggle-card__badge">
                <span v-if="grade.is_active" class="badge bg-success">مفعّل</span>
                <span v-else class="badge bg-secondary">معطّل</span>
              </div>
              <div class="grade-toggle-card__switch">
                <i :class="grade.is_active ? 'pi pi-toggle-on text-success' : 'pi pi-toggle-off text-secondary'" style="font-size: 1.6rem;"></i>
              </div>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.is_reservation_open ? 'btn btn-sm btn-outline-success' : 'btn btn-sm btn-outline-danger'"
                :title="grade.is_reservation_open ? 'اضغط لإغلاق الحجز لهذه السنة.' : 'اضغط لفتح الحجز لهذه السنة.'"
                @click.stop="toggleReservation(grade)"
              >
                <i :class="grade.is_reservation_open ? 'pi pi-lock-open me-1' : 'pi pi-lock me-1'"></i>
                {{ grade.is_reservation_open ? 'الحجز مفتوح' : 'الحجز مغلق' }}
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn btn btn-sm btn-outline-primary"
                title="إعدادات نموذج التسجيل"
                @click.stop="openFormSettings(grade)"
              >
                <i class="pi pi-cog me-1"></i>
                إعدادات النموذج
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.is_subscription_enabled ? 'btn btn-sm btn-outline-warning' : 'btn btn-sm btn-outline-secondary'"
                title="إعدادات الاشتراك والأسعار"
                @click.stop="openSubSettings(grade)"
              >
                <i class="pi pi-money-bill me-1"></i>
                {{ grade.is_subscription_enabled ? 'الاشتراك مفعّل' : 'إعدادات الاشتراك' }}
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.reservation_start_at ? 'btn btn-sm btn-outline-info' : 'btn btn-sm btn-outline-secondary'"
                title="تحديد موعد فتح الحجز لهذه السنة الدراسية"
                @click.stop="openScheduleModal(grade)"
              >
                <i class="pi pi-calendar-clock me-1"></i>
                {{ grade.reservation_start_at ? formatSchedule(grade.reservation_start_at) : 'تحديد موعد الحجز' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Secondary -->
      <div class="stage-section mb-4" v-if="gradesByStage.secondary.length">
        <h5 class="stage-title">
          <i class="pi pi-graduation-cap me-2"></i> المرحلة الثانوية
        </h5>
        <div class="row g-3">
          <div
            v-for="grade in gradesByStage.secondary"
            :key="grade.id"
            class="col-xl-2 col-lg-3 col-md-4 col-6"
          >
            <div
              class="grade-toggle-card"
              :class="{ 'grade-toggle-card--active': grade.is_active }"
              @click="toggle(grade)"
            >
              <div class="grade-toggle-card__name">{{ grade.name }}</div>
              <div class="grade-toggle-card__badge">
                <span v-if="grade.is_active" class="badge bg-success">مفعّل</span>
                <span v-else class="badge bg-secondary">معطّل</span>
              </div>
              <div class="grade-toggle-card__switch">
                <i :class="grade.is_active ? 'pi pi-toggle-on text-success' : 'pi pi-toggle-off text-secondary'" style="font-size: 1.6rem;"></i>
              </div>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.is_reservation_open ? 'btn btn-sm btn-outline-success' : 'btn btn-sm btn-outline-danger'"
                :title="grade.is_reservation_open ? 'اضغط لإغلاق الحجز لهذه السنة.' : 'اضغط لفتح الحجز لهذه السنة.'"
                @click.stop="toggleReservation(grade)"
              >
                <i :class="grade.is_reservation_open ? 'pi pi-lock-open me-1' : 'pi pi-lock me-1'"></i>
                {{ grade.is_reservation_open ? 'الحجز مفتوح' : 'الحجز مغلق' }}
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn btn btn-sm btn-outline-primary"
                title="إعدادات نموذج التسجيل"
                @click.stop="openFormSettings(grade)"
              >
                <i class="pi pi-cog me-1"></i>
                إعدادات النموذج
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.is_subscription_enabled ? 'btn btn-sm btn-outline-warning' : 'btn btn-sm btn-outline-secondary'"
                title="إعدادات الاشتراك والأسعار"
                @click.stop="openSubSettings(grade)"
              >
                <i class="pi pi-money-bill me-1"></i>
                {{ grade.is_subscription_enabled ? 'الاشتراك مفعّل' : 'إعدادات الاشتراك' }}
              </button>
              <button
                type="button"
                class="grade-toggle-card__reservation-btn"
                :class="grade.reservation_start_at ? 'btn btn-sm btn-outline-info' : 'btn btn-sm btn-outline-secondary'"
                title="تحديد موعد فتح الحجز لهذه السنة الدراسية"
                @click.stop="openScheduleModal(grade)"
              >
                <i class="pi pi-calendar-clock me-1"></i>
                {{ grade.reservation_start_at ? formatSchedule(grade.reservation_start_at) : 'تحديد موعد الحجز' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <RegistrationFormSettingsModal
      v-model="formSettingsModalOpen"
      :academic-year-id="formSettingsGradeId"
    />

    <ReservationScheduleModal
      v-model="scheduleModalOpen"
      :academic-year="scheduleModalGrade"
    />

    <SubscriptionSettingsModal
      v-model="subSettingsOpen"
      :year="subSettingsGrade"
      @saved="onSubSettingsSaved"
    />

  </div>
</template>

<script>
import { useGradeStore } from '@/stores/useGradeStore.js';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import RegistrationFormSettingsModal from './RegistrationFormSettingsModal.vue';
import ReservationScheduleModal from './ReservationScheduleModal.vue';
import SubscriptionSettingsModal from './SubscriptionSettingsModal.vue';
import Swal from 'sweetalert2';

const MONTHS_AR = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

export default {
  name: 'AcademicYearsConfig',
  components: { Breadcrumb, RegistrationFormSettingsModal, ReservationScheduleModal, SubscriptionSettingsModal },
  data() {
    return {
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'إعداد السنوات الدراسية', path: '/academic-years' },
      ],
      formSettingsModalOpen: false,
      formSettingsGradeId: null,
      scheduleModalOpen: false,
      scheduleModalGrade: null,
      subSettingsOpen: false,
      subSettingsGrade: null,
    };
  },
  computed: {
    gradeStore() {
      return useGradeStore();
    },
    loading() {
      return this.gradeStore.loading;
    },
    gradesByStage() {
      return this.gradeStore.gradesByStage;
    },
  },
  methods: {
    async toggle(grade) {
      try {
        await this.gradeStore.toggleGrade(grade.id);
        Swal.fire({
          icon: 'success',
          title: grade.is_active ? `تم تعطيل ${grade.name}` : `تم تفعيل ${grade.name}`,
          timer: 1200,
          showConfirmButton: false,
        });
      } catch {
        Swal.fire({ icon: 'error', title: 'حدث خطأ', timer: 2000, showConfirmButton: false });
      }
    },
    async toggleReservation(grade) {
      try {
        await this.gradeStore.toggleReservation(grade.id);
        Swal.fire({
          icon: 'success',
          title: grade.is_reservation_open ? `تم إغلاق الحجز لـ ${grade.name}` : `تم فتح الحجز لـ ${grade.name}`,
          timer: 1200,
          showConfirmButton: false,
        });
      } catch {
        Swal.fire({ icon: 'error', title: 'حدث خطأ', timer: 2000, showConfirmButton: false });
      }
    },
    openFormSettings(grade) {
      this.formSettingsGradeId = grade.id;
      this.formSettingsModalOpen = true;
    },
    openScheduleModal(grade) {
      this.scheduleModalGrade = grade;
      this.scheduleModalOpen = true;
    },
    openSubSettings(grade) {
      this.subSettingsGrade = grade;
      this.subSettingsOpen = true;
    },
    onSubSettingsSaved(updated) {
      // Reflect the saved subscription fields back into the store's cached list.
      const list = this.gradeStore.allGrades;
      const idx = list.findIndex(g => g.id === updated.id);
      if (idx !== -1) list[idx] = { ...list[idx], ...updated };
    },
    formatSchedule(reservationStartAt) {
      const d = new Date(reservationStartAt.replace(' ', 'T'));
      if (Number.isNaN(d.getTime())) return '';
      let h = d.getHours();
      const period = h >= 12 ? 'م' : 'ص';
      h = h % 12 || 12;
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${d.getDate()} ${MONTHS_AR[d.getMonth()]} - ${h}:${minutes} ${period}`;
    },
  },
  async mounted() {
    await this.gradeStore.fetchAllGrades();
  },
};
</script>

<style scoped>
.stage-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--primary-color, #3b82f6);
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
}

.grade-toggle-card {
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 0.75rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.grade-toggle-card:hover {
  border-color: #94a3b8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.grade-toggle-card--active {
  border-color: #22c55e;
  background: #f0fdf4;
}

.grade-toggle-card__name {
  font-weight: 700;
  font-size: 0.95rem;
  margin-bottom: 0.4rem;
}

.grade-toggle-card__badge {
  margin-bottom: 0.4rem;
}

.grade-toggle-card__switch {
  display: flex;
  justify-content: center;
}

.grade-toggle-card__reservation-btn {
  margin-top: 0.5rem;
  width: 100%;
  font-size: 0.75rem;
}
</style>
